import dayjs from 'dayjs';

import {
  INDICATOR_DISPLAY_TYPES_MAP,
  INDICATOR_GROUP_BY_TYPES_MAP,
  IndicatorAnalyzeRangeFilters,
} from './types';

export const defaultFilters = {
  filterType: 'date',
  dateRange: [null, null],
  displayType: INDICATOR_DISPLAY_TYPES_MAP.bar,
  groupByType: INDICATOR_GROUP_BY_TYPES_MAP.day,
} satisfies IndicatorAnalyzeRangeFilters;

export const getDefaultFilters = () => {
  return {
    ...defaultFilters,
    dateRange: [dayjs().subtract(6, 'day'), dayjs()],
  } satisfies IndicatorAnalyzeRangeFilters;
};
